import axios from "axios";
import { PROXY_RATES } from "../envVariables";

// Direct Cloud Run endpoint, or the same-origin Netlify proxy when REACT_APP_PROXY_RATES=YES
// (the proxy also swaps the anonymous JWT placeholder for a real one — see rate-search.mjs).
const DIRECT_URL = "https://rate-api-462238530065.us-central1.run.app/lcl-external-rates";
const PROXY_URL = "/api/lcl-external-rates";

export const makeGCPRequestForLCLCharges = async (payload) => {
    // console.log("--makeGCPRequestForFCLExternalRate--", JSON.stringify(payload, null, 2));

    const url = PROXY_RATES === "YES" ? PROXY_URL : DIRECT_URL;

    try{
        const response = await axios.post(url, payload, {
            headers: { "Content-Type": "application/json" },
        });
        // console.log("----response------",response)

        const { status, data } = response;
        console.log("GCP Response status:", status); 
        if (data?.ok) {
            if (data.error) {
                // Throw an error if API explicitly reports one
                throw new Error(
                `GCP request error: ${typeof data.error === "string" ? data.error : JSON.stringify(data.error)}`
                );
            }

            const results = data?.results;

            // New response shape: { ok: true, results: { status: 'ok', results: {...} } }
            if (results && typeof results === "object" && results.status) {
                if (results.status === "ok") {
                    // console.log("✅ GCP Request for lcl-external-rates accepted", results);
                    return results;
                }

                const errorMsg = results?.error || results.message;
                console.error(`⚠️ LCL quote returned ${results.status}: ${errorMsg || 'Unknown error'}`);
                return [];
            }

            // Legacy array response
            if (Array.isArray(results)) {
                // console.log("✅ GCP Request for lcl-external-rates accepted", results);
                return results;
            }
        }

        console.warn("⚠️ GCP Request for lcl-external-rates not accepted:", data);
        return [];
    }catch(error){
        console.error("error while getting lcl external rate: ",error);
        const responseData = error.response?.data;
        if (responseData) {
            const status =
              responseData?.results?.status ||
              responseData?.status ||
              error.response?.status;
            const message =
              responseData?.results?.error ||
              responseData?.error ||
              responseData?.message ||
              error.message;
            return `LCL charges error (${status || 'unknown'}): ${message}`;
        }
        return `LCL charges request failed: ${error.message}`;
    }
  
}
